export enum WixMediaRoot {
  Backgrounds = 'backgrounds',
  Clipart = 'clipart',
  FileIcons = 'file_icons',
  Icons = 'icons',
  Photos = 'photos',
  Watermarks = 'watermarks',
  Shapes = 'shapes',
  SocialIcons = 'social_icons',
  SocialIconsComponent = 'socialIconsComponent',
  PhotosTest = 'photos_test',
  Videos = 'videos',
  VideosPlus = 'videos_plus',
  VectorArt = 'vector_art',

  Dividers = 'Dividers',

  BackgroundImages = 'bg_images',
  BackgroundIllustrations = 'bg_illustrations',
  Patterns = 'patterns',
  Textures = 'textures',
  Illustrations = 'illustrations',
  Images = 'images',
  BasicShapes = 'basicShapes',
  VectorArtNew = 'vectorArt',
  TransparentVideos = 'transparentVideos',

  // PublicMediaLike
  Ntt = 'ntt',
  Yell = 'Yell',

  BaseUI = 'baseUI_thumbs',

  None = '',
}
